export const SCREENS = {
  WELCOME: "WELCOME",
  SETUP: "SETUP",
  WORLD_SELECT_INTRO: "WORLD_SELECT_INTRO",
};
